import { ReturnAssessmentGroupsSchema } from "@redotech/redo-model/return-assessments/assessment-schemas";

export const createGroup = {
  name: "createGroup" as const,

  input: ReturnAssessmentGroupsSchema.omit({ _id: true }),

  output: ReturnAssessmentGroupsSchema,
};
